<template>
  <div
    :class="[
      classes,
      {
        'raised-bottom': viewport === 'mobile' && isPdpPage,
        'chrome-mobile': isChromeMobile,
      },
    ]"
    :data-preload="[$options.name]"
  >
    <div class="inner">
      <Toast />
    </div>

    <CookiesMain />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Toast from 'Components/02-molecules/toast/Toast';
import CookiesMain from 'Components/03-organisms/cookies-main/CookiesMain';
import globalMixin from 'Libs/mixins/globalMixin';
import DeviceHelper from 'Libs/helpers/device';

export default {
  name: 'ViewportBottom',
  components: {
    Toast,
    CookiesMain,
  },
  mixins: [globalMixin],
  data() {
    return {
      showCookiesBar: false,
      isChromeBrowser: false,
    };
  },
  computed: {
    ...mapState('core', { viewport: ({ viewport: { range } }) => range }),
    ...mapState('productsList', {
      isPdpPage: (state) =>
        state?.component ? state.component === 'ProductDetails' : false,
    }),
    isChromeMobile() {
      return this.isChromeBrowser && this.viewport === 'mobile';
    },
  },
  mounted() {
    this.isChromeBrowser = new DeviceHelper().isChrome();
  },
};
</script>

<style lang="scss" scoped>
@import 'variables/breakpoints';
@import 'mixins';

.viewportBottom {
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 9999;

  &.raised-bottom {
    bottom: 85px;

    ::v-deep .cookies-wrapper {
      bottom: 85px;
    }
  }
}

.inner {
  @include pageWidth;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: var(--space-1);

  .chrome-mobile & {
    position: fixed;
    top: 0;
    left: 0;
    height: 100dvh;
    justify-content: flex-end;
    pointer-events: none;

    ::v-deep .toastItem {
      pointer-events: auto;
    }
  }
}
</style>
